import { AppBar, Divider, IconButton, Stack, Toolbar, useTheme } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { BrandSelect, BrandSelectOption, LanguageSwitch } from '@dap/common/ui';
import { DAPLogo } from '@dap/common/ui';
import { getSettingsRoute } from '@dap/common/consts';
import { LanguageCapitalLettersCode, LanguageCode } from '@shared/types';
import { UserData } from '@dap/memberadmin/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export interface DesktopProps {
  switchLanguage: (languageCode: LanguageCapitalLettersCode) => void;
  language: LanguageCode;
  userData: UserData;
  brands: BrandSelectOption[];
  selectedBrandKey: string;
  onSelectBrand: (brandKey: string) => void;
}

// TODO Seems illogical to need to convert between language codes
function convertLanguageCodeThing(code: LanguageCode) {
  switch (code) {
    case LanguageCode.Norwegian:
      return 'no';
    case LanguageCode.Swedish:
      return 'se';
    default:
      return 'en';
  }
}

export default function Desktop({
  switchLanguage,
  language,
  userData,
  brands,
  selectedBrandKey,
  onSelectBrand,
}: DesktopProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { palette } = useTheme();

  if (!userData) return null;

  // This feels backwards that the components don't use the same language codes
  const convertedLangCode = convertLanguageCodeThing(language);

  return (
    <AppBar position="fixed" sx={{ height: 'auto' }}>
      <Toolbar
        sx={{
          display: 'grid',
          gridTemplateColumns: '235px auto',
          minHeight: {
            xs: '72px',
            sm: '72px',
            md: '72px',
            lg: '72px',
          },
        }}
      >
        <Stack direction="row" alignItems="center" alignSelf="stretch">
          <BrandSelect
            brands={brands}
            selectedBrandKey={selectedBrandKey}
            selectedTitle="Digital Arbeidsplass"
            onBrandSelect={onSelectBrand}
          />

          {/* TODO ASO Implement search field */}
          {/* <Divider
            orientation="vertical"
            sx={{ borderColor: palette.background.default, marginX: 3 }}
          /> */}
        </Stack>

        <Stack direction="row" alignItems="center" height="100%" sx={{ justifySelf: 'end' }}>
          <DAPLogo />

          {/* TODO ASO  Embed WaffleMenu <div>Vaffelmeny</div> */}
          <Stack direction="row" alignItems="center" alignSelf="stretch">
            <Divider
              orientation="vertical"
              sx={{ borderColor: palette.background.default, margin: 3 }}
            />
            {/* TODO ASO  Notification <div>Notifications(?)</div> */}
            <IconButton
              onClick={() => navigate(getSettingsRoute())}
              aria-label={t('settings.title')}
            >
              <SettingsOutlinedIcon />
            </IconButton>
            <LanguageSwitch
              selectedLanguage={convertedLangCode}
              switchLanguage={(langCode) => {
                // This feels backwards that the components don't use the same language codes
                const convertedLangCode = langCode.toUpperCase() as LanguageCapitalLettersCode;
                switchLanguage(convertedLangCode);
              }}
              languages={['no', 'se', 'en']}
            />
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
